import React, { useRef, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import governanceIcon from '../images/governanceIcon.jpg';
import protectingIcon from '../images/protectingIcon.jpg';
import safeGuardingIcon from '../images/safeGuardingIcon.jpg';
import policyAdvocacyImage from '../images/us-capitol-1273914.jpg';
import cybersecurityImage from '../images/AdobeStock_1725140751(2).jpg';
import supplyChainImage from '../images/AdobeStock_337520281.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import CounterAnimation from '../components/CounterAnimation';
import CustomCircularProgressTwoValues from '../components/CustomCircularProgressTwoValues';
import './Pages.css';

export default function Governance()
{
	localStorage.setItem('activeLinkIndex', '7');

	const [activeSection, setActiveSection] = useState('section1');
  const [userClicked, setUserClicked] = useState(false);
  const navigate = useNavigate();
  const leftArrowRef = useRef(null);


  useEffect(() => {

    const handleScroll = () => {
      if (!userClicked) {
        const sections = document.querySelectorAll('.section');
        sections.forEach((section) => {
          const rect = section.getBoundingClientRect();
          const isNearTop = rect.top <= 120 && rect.bottom >= 0;
          if (isNearTop) {
            setActiveSection(section.id);
          }
        });
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [userClicked]);

  const scrollToSection = (sectionId, offset) => 
  {
    const section = document.getElementById(sectionId);
    setUserClicked(true); // Set the flag when a user clicks a menu item
    const offsetTop = section.offsetTop - offset;
	window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    setTimeout(() => {
      setUserClicked(false); // Reset the flag after a delay
    }, 1000); // Adjust the delay as needed
  };

	return (
		<>
		<Container fluid>
			<div className='subMenu'>
				<ul>
					<li 
						onClick={() => { scrollToSection('section1', 90); 	    
										for (let i = 0; i <= 4; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[0].classList.add('active');
				}}>
						<span className={`subMenuItem ${activeSection === 'section1' ? 'active' : ''}`}>Business ethics and integrity</span>
					</li>
					<li 
						onClick={() =>{ scrollToSection('section2', 90); 	    
										for (let i = 0; i <= 4; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[1].classList.add('active');
				}}><span className={`subMenuItem ${activeSection === 'section2' ? 'active' : ''}`}>Enterprise risk management</span></li>
					<li 
						onClick={() =>{ scrollToSection('section3', 90); 	    
										for (let i = 0; i <= 4; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[2].classList.add('active');
				}}><span className={`subMenuItem ${activeSection === 'section3' ? 'active' : ''}`}>Political advocacy and engagement</span></li>
					<li 
						onClick={() =>{ scrollToSection('section4', 90); 	    
										for (let i = 0; i <= 4; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[3].classList.add('active');
				}}><span className={`subMenuItem ${activeSection === 'section4' ? 'active' : ''}`}>Data privacy and cybersecurity</span></li>
					<li 
						onClick={() =>{ scrollToSection('section5', 90); 	    
										for (let i = 0; i <= 4; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[4].classList.add('active');
				}}><span className={`subMenuItem ${activeSection === 'section5' ? 'active' : ''}`}>Supply chain</span></li>
				</ul>
			</div>
			<div className='contentArea sub'>
				<Row className='headerRow gx-5'>
					<h1 data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>Governance</h1>
				</Row>
				<hr/>
				<br/>
				<Row className='gx-5'>
					<Col lg={6}>
						<Row className='gx-5'>
							<Col md={12} className='my-lg-auto mt-3' data-aos='fade-right' data-aos-duration='750' data-aos-once='true'>
								<span className="infographicHeading"><CounterAnimation targetNumber={9} /><sup style={{top: '20px'}}>*</sup></span>
										<br/>
										<span className='infographicSubHeading'>Board members</span>
							</Col>
						</Row>
						<Row className='mt-3'>
							<Col>
							<p style={{fontSize: '0.75rem'}}>*89% of CACI's board members are independent.</p>
							</Col>
						</Row>
						<h2 id='section1' className='mt-5 mb-4 section'>Business ethics and integrity</h2>
						<p>As a company of steady character and informed innovation, we know integrity is essential, especially in matters of national security. Our ethics guide how we deliver positive outcomes for our customers and our nation.</p>
						<h2 id='section2' className='mt-5 mb-4 section'>Enterprise Risk Management</h2>
						<p>CACI’s Enterprise Risk Management (ERM) team reports to the Executive Vice President of Business Operations and oversees reduction of risk to the company, ensuring effective operational, financial, and reputational risk mitigation.</p>
						<p>This team collaborates with risk owners to ensure mitigation plans are effective. The CEO and Board of Directors are briefed on enterprise risks quarterly.</p>
						<h3 className='mt-5 mb-4'>Anti-bribery</h3>
						<p>CACI strictly prohibits all forms of bribery or other improper payments any- where in the world, whether they involve government officials or are wholly commercial, and requires that all international opportunities and activities be pursued and executed in strict compliance with the Foreign Corrupt Practices Act and other applicable anti-bribery laws and regulations.</p>
						<h3 className='mt-5 mb-4'>Export controls</h3>
						<p>As a company dedicated to serving customers that defend and protect the U.S., CACI remains ever vigilant in complying with applicable U.S. trade controls laws, including but not limited to the International Traffic in Arms Regulations (ITAR), Export Administration Regulations (EAR), and the economic sanctions regulations administered by the U.S. Office of Foreign Assets Control (OFAC).</p>
						<p>CACI has a comprehensive, company-wide trade compliance program with detailed policies and procedures designed to ensure trade compliance. CACI’s Global Trade Compliance Office manages the program’s implementation with a dedicated staff of trade compliance subject matter experts.</p>
						<h3 className='mt-5 mb-4'>Counterfeit parts prevention</h3>
						<p>With an increasingly complex and global supply chain, CACI is mindful of the need for extra diligence in identifying, tracking, inspecting, and managing counterfeit electronic parts (CEPs) throughout the supply chain to ensure that products are authentic and critical parts are not compromised. Our approach for managing the flow of materials and successfully mitigating the risks of CEPs involves training, awareness, and an understanding of the programmatic and technical risks at all levels of the supply chain.</p>
					</Col>
					<Col lg={6}>
						<div className='table-container mt-lg-5' data-aos='fade-up' data-aos-duration='750' data-aos-once='true'>
							<Table>
								<thead>
									<tr style={{borderBottom: '4px solid #000', fontWeight: '700', color: '#000'}}>
										<td>Board Committee</td>
										<td>ESG Topics Addressed</td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td style={{borderBottom: '1px solid grey', fontWeight: '600'}}>Corporate Governance and Nominating Committee</td>
										<td style={{borderBottom: '1px solid grey'}}>
											<ul style={{fontWeight: '300'}}>
												<li>Review policies and practices of the company and monitor compliance in areas of corporate governance and ethics and report and make recommendations to the Board with respect to such policies and practices, assessing, among other things, (a) the company’s Standards of Ethics and Business Conduct (the “Standards of Conduct”) and the Directors’ Code of Business Ethics and Conduct, and (b) other internal corporate governance policies and practices.</li>
												<li>Review the oversight framework for effective governance and board oversight, to include compliance with SEC and NYSE requirements and review of the Proxy Statement. Review the company’s environmental policies, programs and Corporate Responsibility Report.</li>
											</ul>
										</td>
									</tr>
									<tr>
										<td style={{borderBottom: '1px solid grey', fontWeight: '600'}}>Human Resources and Compensation Committee</td>
										<td style={{borderBottom: '1px solid grey'}}>
											<ul style={{fontWeight: '300'}}>
												<li>Review support to ESG initiatives as part of the company’s incentive programs.</li>
												<li>Approve ESG initiatives and linkage to executive compensation; oversee human capital risks and review talent management programs; receives updates from the CHRO and review the CD&A; oversee community relations programs and facilitate board oversight of culture initiatives.</li>
											</ul>
										</td>
									</tr>
									<tr>
										<td style={{borderBottom: '1px solid grey', fontWeight: '600'}}>Audit and Risk Committee</td>
										<td style={{borderBottom: '1px solid grey'}}>
											<ul style={{fontWeight: '300'}}>
												<li>To review periodically the environmental related risks to the company, internal controls over publicly reported data in the Corporate Responsibility Report and audit and assurance processes for environmental reporting.</li>
												<li>To oversee internal controls over all publicly reported data in the Corporate Responsibility Report; related audit and assurance processes.</li>
												<li>To review corporate responsibility, data privacy and security, health and safety programs.</li>
												<li>To discuss with management the company’s international policies and export control, FCPA, anti-corruption and related operations and any risks associated with the company’s international operations.</li>
											</ul>
										</td>
									</tr>
								</tbody>
							</Table>
						</div>
					</Col>
				</Row>
				<br/>
				<Row className='gx-5 mt-5'>
					<Col lg={6}>
						<h2 id='section3' className='mt-5 mb-4 section'>Political advocacy and engagement</h2>
						<p>By interacting with policymakers in the executive and legislative branches of government, we understand the needs of our customers and we support their missions.</p>
						<p>Our long-standing ethical policies and procedures ensure that all outreach and communications are conducted in accordance with federal law and without affiliation to any political party. For more than 60 years, we have collaborated with multiple presidential administrations and Congresses, regardless of party affiliation.</p>
						<h3 className='mt-5 mb-4'>Oversight</h3>
						<p>Our standards and culture are the bedrock of our commitment to ethics and integrity that CACI was founded on and remain the touchstone by which our leadership and employees conduct themselves. The President and CEO or the Senior Vice President for Government and Industry Relations must preapprove all external interactions with congressional members and staff. This oversight ensures that the engagement is conducted with the highest standards of ethics and integrity, compliance with federal regulations, and in support of the company’s interests.</p>
						<h3 className='mt-5 mb-4'>CACI Political Action Committee</h3>
						<p>The CACI Political Action Committee (PAC) is an independent, non-partisan, separate, segregated fund comprised of voluntary contributions from our employees. The PAC helps our staff have a collective voice in support of members of Congress whose policies align with our mission of supporting our national security. Involvement in the PAC is voluntary and doesn’t affect an employee’s rights or company standing. The President and CEO appoints CACI PAC leadership to ensure transparency and non-partisanship.</p>
						<p>Contributions made by CACI PAC to political candidates are in accordance with and reported to the Federal Election Commission (FEC) and can be viewed on CACI PAC’s FEC Profile.</p>
						<h3 className='mt-5 mb-4'>Lobbying and industry groups</h3>
						<p>We have contracts with multiple lobbying firms that engage with lawmakers on our behalf. All lobbying activities are reported to the secretary of the U.S. Senate and the clerk of the U.S. House of Representatives, and are publicly available. CACI participates in industry groups with shared interests to promote policies that align with our mission.</p>
					</Col>
					<Col lg={6}>
						<img alt='The United States Capital in Washington, D.C.' data-aos='fade-left' data-aos-duration='750' data-aos-once='true' src={policyAdvocacyImage} style={{width: '100%'}} />
					</Col>
				</Row>
				<br/>
				<Row className='gx-5'>
					<Col lg={6}>
						<br/>
						<div className='stat'>
							<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
								<img alt='An icon of a scale with a piece of paper behind it.' src={governanceIcon} style={{width: '100%'}}/>
							</div>
							<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight'>
								<span className="infographicHeading">Govern</span>
								<br/>
								<span className='infographicSubHeading'>Robust practices to<br/> ensure the security of<br/> personal information.</span>
							</div>
						</div>
						<br/>
						<div className='stat'>
							<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
								<img alt='An icon of a shield with a cloud behind it.' src={protectingIcon} style={{width: '100%'}}/>
							</div>
							<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight'>
								<span className="infographicHeading">Protect</span>
								<br/>
								<span className='infographicSubHeading'>Active deterrence against<br/> loss or theft.</span>
							</div>
						</div>
						<br/>
						<div className='stat'>
							<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
								<img alt='An icon of a motherboard chip with a lock on it.' src={safeGuardingIcon} style={{width: '100%'}}/>
							</div>
							<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight'>
								<span className="infographicHeading">Safeguard</span>
								<br/>
								<span className='infographicSubHeading'>Strong mitigation of<br/> unauthorized disclosure,<br/> copy, use, or modification<br/> of data.</span>
							</div>
						</div>
						<br/>
						<img alt='The United States Capital in Washington, D.C.' data-aos='fade-right' data-aos-duration='750' data-aos-once='true' src={cybersecurityImage} style={{width: '100%'}} />
					</Col>
					<Col lg={6}>
						<h2 id='section4' className='mt-5 mb-4 section'>Data privacy and cybersecurity</h2>
						<p>We are cognizant of our responsibility to manage employee and customer data. It is critical to our mission and business to maintain the security and confidentiality of data protected.</p>
						<p>The Audit and Risk Committee assists the Board of Directors in overseeing CACI’s security. This committee monitors security and reputational risks, and ensures employees follow best practices for data privacy and security.</p>
						<p>In case of a data breach, all affected individuals whose data may have been compromised are promptly notified. Actions are taken to prevent further damage. Any data breaches are disclosed on our public website.</p>
						<h3 className='mt-5 mb-4'>Data privacy policy</h3>
						<p>CACI is committed to protecting employee privacy. Our U.S. privacy policy, supplemented by regionally specific policies, creates a comprehensive approach to data protection principles and complies with all applicable international rules and regulations across our network. CACI continues to evolve our processes to meet new and emerging data protection and privacy challenges. Employees are expected to take proactively protect their personal data, as well as customer and program data, including requests for their individual data to be deleted. All new hires must attend privacy and security awareness training, and all employees are required to complete annual cybersecurity training.</p>
						<h3 className='mt-5 mb-4'>Cybersecurity</h3>
						<p>CACI’s cybersecurity program prevents, detects, and responds to malicious cyber activities that could adversely affect the confidentiality, integrity, or availability of the information or information systems of CACI or our customers.</p>
						<h3 className='mt-5 mb-4'>The cybersecurity program includes:</h3>
						<ul>
							<li>Security design and engineering for existing and emerging technologies, including defensive posture against AI-generated threats.</li>
							<li>Annual training for all employees to heighten threat awareness while operating on the CACI network, public infrastructure, or while on personal or business travel.</li>
							<li>Mandatory suppliers’ and subcontractors’ execution of the CACI acceptable use agreement.</li>
							<li>Identification and access control of high value/risk information.</li>
							<li>Implementation of sophisticated monitoring and defensive capabilities.</li>
							<li>Annual testing and updating of our rapid incident response policy and process.</li>
							<li>Policy enforced application and web browsing technology to protect CACI and our customer data while operating on CACI managed assets.</li>
						</ul>
						<p>CACI is ISO 27001-certified. ISO 27001 ensures the implementation of adequate and proportionate security controls for CACI’s information security management systems, enabling us to maintain security controls customized to the needs of our customers. By utilizing this standard, we lower costs to the customer through effective prevention and mitigation of incidents, and support the mission to avoid interruption of service, ensure data integrity, and promote customer satisfaction.</p>
						<p>CACI’s cyber governance structure complies with new SEC standards, applicable government requirements, and best practices, including DFAR 252.204-7012 and NIST 800-171. CACI adheres to NIST 800-218 and the Secure Software Development Framework (SSDF) for all software development efforts. We continuously monitor our operations, policies, controls, and compliance with internal policies, regulatory requirements, and applicable laws. Our robust supply chain risk management program ensures our vendors meet customer and CACI cybersecurity policies before being allowed to handle data, including a multi-faceted supplier screening process before supplier onboarding.</p>
						<p>CACI’s cybersecurity strategy reduces risk, financial and/or customer impact, and reputational damages by orchestrating a cyber-resilient framework. Our network is based on a zero-trust architecture, which removes implicit trust for devices and users. Continuous monitoring and behavior-based analytics act as additional layers of verification to further reduce our risk posture. Multiple audit and correlation points assess and either grant or deny appropriate trusts from the network transport layer up through the application and identity constructs, while continuously monitoring all activity for signs of anomalous or malicious intent.</p>
						<p>Avoiding traditional cybersecurity defense approaches allows CACI to remove the categorical delineation of the “corporate network” and allows CACI to extend our network operating presence to cloud- and SaaS-based resources. These tools provide additional value to our customers, further distributing and reducing risk while maintaining control and security monitoring.</p>
						<p>Managing vulnerabilities to mitigate threat exploitation is a dynamic process that includes perpetual scanning, remediation, and validation. Quantitative vulnerability metrics are continuously monitored and assessed on our core IT networks and are addressed per policy requirements. If a system is not patched accordingly, it is escalated and either mitigated satisfactorily or taken offline.</p>
					</Col>
				</Row>
				<br/>
				<Row className='gx-5'>
					<Col lg={6}>
						<h2 id='section5' className='mt-5 mb-4 section'>Supply chain</h2>
						<p>Our supply chain management approach is efficient, reliable, and dynamic, leveraging the same expertise and technology we deliver to our customers. Our modern methodology draws from automated agile processes, advanced analytics, and operational dashboards to create efficiencies in the supply chain. We have high standards and we expect our supply chain partners to carry the same ethical values.</p>
						<h3 className='mt-5 mb-4'>Doing business with CACI</h3>
						<p>We choose suppliers that share the values stated in our <a href="https://s21.q4cdn.com/708811725/files/doc_governance/2025/Jan/31/B035_2501_CodeofEthics-bc4eeb.pdf" target="_blank" rel="noopener noreferrer">Standards of Ethics and Business Conduct</a> ,and agree to adhere to these principles, which include maintaining a work environment that:</p>
						<ul>
							<li>Provides opportunities to all employees without regard to their race, color, creed, religion, gender, age, national origin, citizenship status, sexual orientation, physical or mental disability, marital, or veteran status, or any other protected status.</li>
							<li>Ensures that all employment is voluntary, legal, and complies with all applicable child and forced labor laws, including those relating to minimum age limits, limitations of hours worked, compensation, and prohibitions against certain types of work.</li>
							<li>Is free from all forms of discrimination and harassment, including sexual harassment.</li>
							<li>Protects the health and safety of its employees and complies with all federal, state, and local health and safety laws and regulations.</li>
						</ul>
						<p>We expect our suppliers to monitor, identify, investigate, and disclose improper conduct, violation of our standards, or any applicable laws.</p>
						<p>CACI maintains a Defense Contract Management Agency (DCMA)-approved purchasing system and adheres to all the requirements prescribed under the Federal Acquisition Regulations (FAR). When contracting on behalf of our federal government clients, we require our suppliers, their employees, and any providers to comply with applicable laws and federal regulations, our <a href="https://www.caci.com/sites/default/files/2025-02/CACI%20Supplier%20Code%20of%20Conduct.pdf" target="_blank" rel="noopener noreferrer">Supplier Code of Conduct</a>, CACI contractual provisions <a href="https://supplier.caci.com/page.aspx/en/usr/login?ReturnUrl=%2fpage.aspx%2fen%2fbuy%2fhomepage" target="_blank" rel="noopener noreferrer">portal</a>, and supplier internal policies to include:</p>
						<Row>
							<Col md={6}>
								<ul>
									 <li>Harassment</li>
									 <li>Wage and benefits</li>
									 <li>Child labor</li>
									 <li>Human trafficking</li>
									 <li>Drug-free workplace</li>
									 <li>Health and safety</li>
									 <li>Environment and sustainability</li>
									 <li>Conflicts of interest</li>
									 <li>Open-source software (OSS)</li>
									 <li>Procurement integrity</li>
								</ul>
							</Col>
							<Col md={6}>
								<ul>
										<li>Anti-corruption laws (U.S. Foreign Corrupt Practices Act and the U.K. Bribery Act)</li>
									 <li>Fair competition and antitrust</li>
									 <li>Gifts and business courtesies</li>
									 <li>Insider trading</li>
									 <li>Conflict minerals</li>
									 <li>Counterfeit parts</li>
									 <li>Cybersecurity</li>
								</ul>
							</Col>
						</Row>
					</Col>
					<Col lg={6}>
						<img alt='A map of the world with interconnecting lines' data-aos='fade-left' data-aos-duration='750' data-aos-once='true' src={supplyChainImage} style={{width: '100%'}} />
					</Col>
				</Row>
				<br/>
				<Row className='gx-5'>
					<Col lg={6}>
						<h3 className='mt-5 mb-4'>Supply chain approach</h3>
						<p>Our supply chain team strives to remain a world-class solution provider by employing innovative tools and agile processes that align with customers’ mission goals and objectives.</p>
						<p>CACI’s approved purchasing systems employ automated agile processes and predictive analytics. We leverage strategic partnerships with our diverse supplier base, which is predominantly comprised of small businesses.</p>
						<p>Our sourcing methodology is largely centered around the competitive acquisition process that yields a broad spectrum of suppliers.</p>
						<p>We employ a strong supply chain training program that includes formal classroom courses, seminars, mentoring, and on-the-job training. We offer more than 50 courses annually, focusing on improving program-level support and procurement effectiveness through increased customer engagement.</p>
						<h3 className='mt-5 mb-4'>Supplier cybersecurity</h3>
						<p>Our suppliers must comply with applicable Defense Federal Acquisition Regulation Supplement (DFARS) and FAR requirements to perform work for the U.S. government on our behalf. These regulations mitigate cybersecurity risks and safeguard data. Our supplier outreach series provides free semiannual training on these standards to our small business partners</p>
					</Col>
					<Col lg={6}>
						<h3 className='mt-5 mb-4'>Qualifying our suppliers</h3>
						<p>We carefully vet and screen our U.S. and foreign suppliers to ensure they meet our responsibility standards and quality requirements. All new suppliers complete a qualification process before final selection. This process utilizes evaluation and monitoring activities, which include, but are not limited to:</p>
						<ul>
							<li>Denied party screening of more than 70 databases prior to award and automatic re-screening of active supplier records against daily changes made to denied parties lists</li>
							<li>Pre-award supplier financial health and ongoing monitoring of key performance risk indexes post-award</li>
							<li>Quarterly onsite evaluations of performance and regulatory compliance with our strategic suppliers</li>
							<li>Supplier past performance scorecard reviews and ongoing surveyance and dashboard reporting of critical supplier quality and performance metrics</li>
							<li>Development of corrective action plans that include methods to contain, correct, and prevent future non-conformances</li>
							<li>Pre-award supplier Cyber Supply Chain Risk Management (C-SCRM) assessments to ensure adequate systems and processes are in place to safeguard sensitive and proprietary information and to mitigate the threat of unauthorized access or disclosure</li>
						</ul>
							<p>Should a supplier’s violations of our standards of ethics and business conduct become known to CACI and not corrected, CACI will discontinue the business relationship. There were no suppliers identified as having a significant actual or potential negative social impact on the CACI supply chain between 2019-2025.</p>
							<p>Our supplier base is continuously monitored after their initial approval. A supplier will be disqualified if their processes or status adversely change.</p>
					</Col>
				</Row>
				<br/>
				<Row className='gx-5 pb-5'>
					<Col lg={6}>
						<h3 className='mt-5 mb-4'>Small business program</h3>
						<p>CACI supports small business growth through subcontract awards. Our Small Business Advocacy Office (SBAO) has been vital to addressing client needs for more than 30 years. We have worked with thousands of disadvantaged, women-owned, HUBZone, veteran-owned, and service-disabled veteran-owned small businesses, many of which have grown into large corporations.</p>
						<p>The SBAO enhances our small business partners’ capabilities to increase their growth opportunities. We actively engage with small businesses through focused outreach. We are proud of our collaborative work with small businesses, including veteran-owned small businesses, having awarded 46% of our subcontracting dollars to small businesses in FY 2025, 38% of which were veteran-owned and service-disabled, veteran- owned.</p>
						<p>In FY 2025, the scope of CACI’s procurement activity involved managing thousands of active suppliers primarily located in the U.S. and more than a billion dollars in procurement spend to small businesses.</p>
					</Col>
					<Col lg={6} className='mt- mt-lg-5'>
						<div className='p-3' style={{backgroundColor: '#f2f2f2'}}>
							<h3>Mentor Protégé Program</h3>
							<p>We recognize that large businesses play an important role in mentoring and providing opportunities to small businesses, helping them to develop capabilities and employee skill sets and expand their service offerings. CACI has a well-established and award-winning Mentor Protégé Program and has received seven Nunn-Perry awards since 2014. Currently, there are four small businesses in our Mentor Protégé Program receiving a broad range of management, technical, and developmental assistance.</p>
							</div>
					</Col>
				</Row>
				<br/>
				<Row className='pb-5'>
					<Col lg={12} className='my-auto'>
						<Row>
								<Row>
									<Col lg={12}>
										<span className='mb-4 supplierSpendHeader text-center text-lg-start' style={{fontWeight: '600'}}>SUPPLIER SPEND FY 2024</span>
									</Col>
							</Row>
							<div style={{padding: '0'}} className='governanceChart'>
								<div style={{width: '300px'}}>
								<CustomCircularProgressTwoValues
									        size={300}
									        progressColors={['#8C8C8C', '#000']}
									        targetValues={[46, 54]}
									        rotationAngle={0}
									        lineBreakValue={0}
									        textValue1='Large'
									        textValue2='Small'
									      />
							</div>
							</div>
							<div style={{color: '#fff', fontWeight: '600', padding: '0', fontSize: '0.85rem'}} className='governanceChartGradients'>
								<div style={{height: '30%', width: '100%', backgroundImage: 'linear-gradient(to right, #e4e4e3, 10%, #9e9f9e)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
									<span style={{textAlign: 'center', width: '100%'}}>
										<div className='stat' style={{marginBottom: '0px'}}>
											<div className='statFloatLeft' style={{fontSize: '1.25rem', paddingRight: '0', textAlign: 'right'}}>
												22<sup>%</sup>
											</div>
											<div className='statFloatRight'>
												Woman-Owned Small Business
											</div>
										</div>
									</span>
								</div>
								<div style={{height: '26%', width: '100%', backgroundImage: 'linear-gradient(to right, #e4e4e3, 10%, #8a8b8a)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
									<span style={{textAlign: 'center', width: '100%'}}>
										<div className='stat' style={{marginBottom: '0px'}}>
											<div className='statFloatLeft' style={{fontSize: '1.25rem', paddingRight: '0', textAlign: 'right'}}>
												22<sup>%</sup>
											</div>
											<div className='statFloatRight'>
												Veteran-Owned Small Business
											</div>
										</div>
									</span>
								</div>
								<div style={{height: '16%', width: '100%', backgroundImage: 'linear-gradient(to right, #e4e4e3, 10%, #777776)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
									<span style={{textAlign: 'center', width: '100%'}}>
										<div className='stat' style={{marginBottom: '0px'}}>
											<div className='statFloatLeft' style={{fontSize: '1.25rem', paddingRight: '0', textAlign: 'right'}}>
												20<sup>%</sup>
											</div>
											<div className='statFloatRight'>
												HUBZone Business
											</div>
										</div>
									</span>
								</div>
								<div style={{height: '16%', width: '100%', backgroundImage: 'linear-gradient(to right, #e4e4e3, 10%, #636463)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
									<span style={{textAlign: 'center', width: '100%'}}>
										<div className='stat' style={{marginBottom: '0px'}}>
											<div className='statFloatLeft' style={{fontSize: '1.25rem', paddingRight: '0', textAlign: 'right'}}>
												20<sup>%</sup>
											</div>
											<div className='statFloatRight'>
												Disadvantaged Small Business
											</div>
										</div>
									</span>
								</div>
								<div style={{height: '12%', width: '100%', backgroundImage: 'linear-gradient(to right, #e4e4e3, 10%, #4d4e4d)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
									<span style={{textAlign: 'center', width: '100%'}}>
										<div className='stat' style={{marginBottom: '0px'}}>
											<div className='statFloatLeft' style={{fontSize: '1.25rem', paddingRight: '0', textAlign: 'right'}}>
												16<sup>%</sup>
											</div>
											<div className='statFloatRight'>
												Service-Disabled Veteran-Owned Small Business
											</div>
										</div>
									</span>
								</div>
							</div>
						</Row>
					</Col>
				</Row>
			</div>
		<div style={{ clear: 'both' }}></div>
		</Container>
		 <div className='navigationArrows'>
        <div ref={leftArrowRef} className='arrowContainer leftArrow' 
onTouchStart={() => {
                    leftArrowRef.current.classList.add('arrowTouchActive');
                }}
            onTouchEnd={() => {
                    leftArrowRef.current.classList.remove('arrowTouchActive');
                }} onClick={() => {
              navigate('/social');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[6].classList.add('active');
              document.getElementsByClassName('underline')[6].classList.add('active');
            }}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </div>
      </div>
		</>
	);
}